import {
  CreateLeaveRequestArgs,
  LeaveRequest,
  LeaveRequestDTO,
} from "@/models/leave-requests.model";
import apiClient from "./apiClient";
import { getUTCDate } from "@/utils/date-format";
import axios from "axios";
import { PaginatedLeaveResponse } from "@/features/leaveRequests/leaveRequestSlice";

export const getLeaveRequests = async ({
  page,
  limit,
  search,
  status,
  type,
}: {
  page?: number;
  limit?: number;
  search?: string;
  status?: string[];
  type?: string[];
}) => {
  const params = new URLSearchParams();

  if (page !== undefined) params.append("page", page.toString());
  if (limit !== undefined) params.append("limit", limit.toString());
  if (search) params.append("search", search);
  if (status?.length) params.append("status", status.join(","));
  if (type?.length) params.append("type", type.join(","));


  const res = await apiClient.get(`/leave-requests?${params.toString()}`);
  const data = res.data as PaginatedLeaveResponse;
  return data;
};


export const getLeaveRequestsCountByStatus = async (): Promise<{
  APPROVED: number;
  PENDING: number;
  REJECTED: number;
  TOTAL: number;
}> => {
  const res = await apiClient.get(`/leave-requests/count`);
  const data = res.data as {
    APPROVED: number;
    PENDING: number;
    REJECTED: number;
    TOTAL: number;
  };
  return data;
}
export const getUserLeaveRequestsCountByStatus = async (userId: number): Promise<{
  APPROVED: number;
  PENDING: number;
  REJECTED: number;
  TOTAL: number;
}> => {
  const res = await apiClient.get(`/users/${userId}/leave-requests/count`);
  const data = res.data as {
    APPROVED: number;
    PENDING: number;
    REJECTED: number;
    TOTAL: number;
  };
  return data;
}

export const deleteRequest = async (leaveId: number) => {
  const res = await apiClient.delete(`/leave-requests/${leaveId}`);
  return true;
};

export const updateLeaveRequestStatus = async (
  isApproved: boolean,
  leaveRequestId: number
) => {
  const res = await apiClient.patch(`/leave-requests/${leaveRequestId}`, {
    status: isApproved ? "APPROVED" : "REJECTED",
  });
  const data: LeaveRequest = res.data as LeaveRequest;
  return data;
};

export const createLeaveRequest = async (args: CreateLeaveRequestArgs) => {
  const res = await apiClient.post("/leave-requests", {
    ...args,
    fromDate: getUTCDate(args.fromDate),
    toDate: getUTCDate(args.toDate),
  });
  const data: LeaveRequest = res.data as LeaveRequest;
  return data;
};

export const getLeaveRequestsOfUser = async ({
  userId,
  page,
  limit,
  status,
  type,
}: {
  userId: number;
  page?: number;
  limit?: number;
  search?: string;
  status?: string[];
  type?: string[];
}) => {
  const params = new URLSearchParams();
  if (page !== undefined) params.append("page", page.toString());
  if (limit !== undefined) params.append("limit", limit.toString());
  if (status?.length) params.append("status", status.join(","));
  if (type?.length) params.append("type", type.join(","));

  const res = await apiClient.get(`/users/${userId}/leave-requests?${params.toString()}`);
  const data = res.data as PaginatedLeaveResponse;
  console.log('data', data);
  return data;
};

export const getLeaveRequest = async (leaveRequestId: number): Promise<LeaveRequestDTO> => {
  const res = await apiClient.get(`/leave-requests/${leaveRequestId}`);
  const data: LeaveRequestDTO = res.data as LeaveRequestDTO;
  return data;
};


export const getS3UploadUrl = async (fileName: string, fileType: string) => {
  const res = await apiClient.get(`/s3/upload-url?fileName=${fileName}&fileType=${fileType}`);
  const data = res.data;
  return data;
}

export const uploadFileToS3 = async (file: File, uploadUrl: string) => {
  const options = {
    headers: {
      "Content-Type": file.type,
    },
  };
  const res = await axios.put(uploadUrl, file, options);
  return res;
}

export const getSignedUrl = async (fileUrl: string) => {
  const res = await apiClient.get(`/s3/signed-url?fileUrl=${fileUrl}`);
  const data = res.data;
  return data;
}